module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Italic.32dd0899.woff";